import { User } from '@centecomm/portal-service';
import * as FullStory from '@fullstory/browser';
import React from 'react';
import FullStoryContext from '../FullStoryContext';

/**
 * Identifies the currently logged in user in FullStory.
 * @param user - The currently logged in user.
 * @returns fullStoryIdentified - Whether or not the user has been identified in FullStory.
 */
const useIdentify = (user?: User): boolean => {
    const { ready } = React.useContext(FullStoryContext);
    const [fullStoryIdentified, setFullStoryIdentified] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (fullStoryIdentified || !user || !ready) return;

        FullStory.identify(user.email, {
            displayName: `${user?.firstName} ${user?.lastName}`,
            email: user.email,
        });

        setFullStoryIdentified(true);
    }, [user, ready, fullStoryIdentified]);

    return fullStoryIdentified;
};

export default useIdentify;
